import React from "react";
import PropTypes from "prop-types";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Button } from "./Button";

/**
 * 通用對話框（design system primitive）。
 * 比 ConfirmDialog 更泛用：自訂 body、footer、尺寸；預設提供 取消/確認。
 *
 *   <Dialog isOpen toggle title="編輯機房" size="lg"
 *           onConfirm={save} confirmText="儲存" confirmLoading={saving}>
 *     <FormBody/>
 *   </Dialog>
 *
 * 傳 footer 可完全自訂底部；傳 hideFooter 則不顯示。
 *
 * 不傳 toggle = 這個對話框關不掉:沒有右上角 ×、沒有取消鈕、點背景與按 Esc 都不會關。
 * 用在「非做不可」的流程(例如首次登入強制變更密碼),不要拿來擋一般操作。
 */
export const Dialog = ({
  isOpen,
  toggle,
  title,
  size = "md",
  centered = true,
  scrollable = false,
  onConfirm,
  confirmText = "確認",
  cancelText = "取消",
  confirmVariant = "primary",
  confirmLoading = false,
  confirmDisabled = false,
  hideFooter = false,
  footer,
  children,
}) => (
  <Modal
    isOpen={isOpen}
    toggle={toggle}
    size={size}
    centered={centered}
    scrollable={scrollable}
    backdrop={toggle ? true : "static"}
    keyboard={!!toggle}
  >
    {title ? <ModalHeader toggle={toggle}>{title}</ModalHeader> : null}
    <ModalBody>{children}</ModalBody>
    {hideFooter ? null : (
      <ModalFooter>
        {footer || (
          <>
            {/* 稿的 Secondary Button(元件 22:4642)是 #6c757d 實底,不是淺底 light
                —— ConfirmDialog 8/12 已改,這裡是同一顆元件的另一個入口(drift check 8/12) */}
            {toggle ? <Button variant="secondary" onClick={toggle}>{cancelText}</Button> : null}
            {onConfirm ? (
              <Button
                variant={confirmVariant}
                loading={confirmLoading}
                disabled={confirmDisabled}
                onClick={onConfirm}
              >
                {confirmText}
              </Button>
            ) : null}
          </>
        )}
      </ModalFooter>
    )}
  </Modal>
);
Dialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  // 不給 = 關不掉(見上方說明)
  toggle: PropTypes.func,
  title: PropTypes.node,
  size: PropTypes.oneOf(["sm", "md", "lg", "xl"]),
  centered: PropTypes.bool,
  scrollable: PropTypes.bool,
  onConfirm: PropTypes.func,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  confirmVariant: PropTypes.string,
  confirmLoading: PropTypes.bool,
  confirmDisabled: PropTypes.bool,
  hideFooter: PropTypes.bool,
  footer: PropTypes.node,
  children: PropTypes.node,
};

export default Dialog;
